import type { CSSProperties } from 'react';

import classnames from 'classnames';

import { getWidthStyle } from '../utils/sizing';

import { SPACER_DEFAULTS } from './Spacer.constants';
import * as styles from './Spacer.css';
import type { SpacerElementProps } from './Spacer.types';

export function SpacerElement(props: SpacerElementProps) {
  const { element, children, attributes, className } = props;
  const { height, width, mobile_hide, desktop_hide, customAttributes, margin } = element.attrs || {};

  const [marginTop, marginRight, marginBottom, marginLeft] = (margin ?? SPACER_DEFAULTS.margin).toString().split(' ');

  return (
    <div
      {...customAttributes}
      className={classnames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.spacerElement,
        customAttributes?.className,
      )}
      style={
        {
          height: `${height}px`,
          ...getWidthStyle(width),
          '--margin-top': marginTop,
          '--margin-right': marginRight,
          '--margin-bottom': marginBottom,
          '--margin-left': marginLeft,
          '--margin': margin ?? SPACER_DEFAULTS.margin,
        } as CSSProperties
      }
      {...attributes}
    >
      {/* to get slate editor works */}
      {children}
    </div>
  );
}
